// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"31ba663a","543":"c0bb7b4e","604":"dadd17e0","885":"4f6fdfe5"}[chunkId] + ".chunk.js";
};